import TriagePopup from './TriagePopup';

export default TriagePopup;
